import React, { useState } from 'react';
import { LoadingButton } from '@one-thd/sui-atomic-components';
import SorisQrDrawer from '../soris-return-qr-drawer/SorisQrDrawer';
import { getSorisQrCode } from '../../../api/returns/soris-api';
import { TriggerViewQRCodeAnalytics } from '../../../utils/analytics';
import useFetchState from '../../../hooks/useFetchState';
var SorisQRButton = function (_a) {
    var fulfillmentGroup = _a.fulfillmentGroup, orderId = _a.orderId, emailId = _a.emailId, net = _a.net, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    var _c = useState(false), displaySorisDrawer = _c[0], setDisplaySorisDrawer = _c[1];
    var _d = useFetchState(), QRResponse = _d.data, loading = _d.loading, errorMsg = _d.errorMsg, fetchData = _d.fetchData;
    var sorisId = fulfillmentGroup.returnOrderNumber || '';
    var items = (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) || [];
    var openDrawer = function (event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        TriggerViewQRCodeAnalytics();
        var isGuest = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === '/myaccount/guest-order-tracking';
        var getSorisQrCodeRequest = {
            orderId: orderId,
            emailId: emailId,
            isGuest: isGuest,
            net: net,
            sorisId: sorisId,
        };
        fetchData(function () { return getSorisQrCode(getSorisQrCodeRequest); }).finally(function () {
            return setDisplaySorisDrawer(true);
        });
    };
    var closeDrawer = function () { return setDisplaySorisDrawer(false); };
    return (React.createElement("div", { className: "card-fix sui-order-1" },
        React.createElement(LoadingButton, { loading: loading, onClick: openDrawer, variant: variant },
            React.createElement("span", null, "View In-Store Return QR Code")),
        React.createElement(SorisQrDrawer, { displaySorisDrawer: displaySorisDrawer, closeDrawer: closeDrawer, qrCodeImg: QRResponse === null || QRResponse === void 0 ? void 0 : QRResponse.sorisQrImg, sorisId: sorisId, sorisQrApiError: !!errorMsg, items: items })));
};
export default SorisQRButton;
